import { Link, useLocation, useNavigate } from "react-router";
import { CourseworkGroups } from "@/components/assignments/coursework/CourseworkGroups";
import { groupsOrigin, groupsReturnState, historyIndex } from "@/components/assignments/coursework/groups-origin";
import { usePartHeading } from "./course-part";

/**
 * People's course groups (#1393 R2), addressed by `?part=groups`. Opened from
 * a work's audience, Return reaches that exact work: Back when the entry
 * before this one is it, otherwise its exact address, so a plain and a
 * modified click land in the same place. A group save stays here with its own
 * recovery.
 */
export function CourseGroupsPart({ courseId, writable, timezone }: { courseId: string; writable: boolean; timezone?: string }) {
  const heading = usePartHeading("groups");
  const location = useLocation();
  const navigate = useNavigate();
  const origin = groupsOrigin(location.state, courseId, location.pathname);
  return <div className="grid gap-3 pt-6" data-part="groups">
    {origin && <Link to={origin.href} dir="auto" className="inline-flex min-h-11 w-fit items-center text-ui font-semibold text-primary underline-offset-4 hover:underline" onClick={event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      const here = historyIndex();
      if (origin.idx !== undefined && here === origin.idx + 1) navigate(-1);
      else navigate(origin.href, { state: groupsReturnState(null) });
    }}>{`Return to ${origin.title.trim() || "the coursework"}`}</Link>}
    <CourseworkGroups course={courseId} writable={writable} timezone={timezone} headingRef={heading} />
  </div>;
}
